<template>
  <TableLayout :permissions="['business:orderlog:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="主键" prop="id">
        <el-input v-model="searchForm.id" placeholder="请输入主键" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="是否已删除 0未删除 1已删除" prop="deleted">
        <el-input v-model="searchForm.deleted" placeholder="请输入是否已删除 0未删除 1已删除" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="创建人编码" prop="createUser">
        <el-input v-model="searchForm.createUser" placeholder="请输入创建人编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="创建时间" prop="createTime">
        <el-date-picker v-model="searchForm.createTime" value-format="yyyy-MM-dd" placeholder="请输入创建时间" @change="search"/>
      </el-form-item>
      <el-form-item label="更新人编码" prop="updateUser">
        <el-input v-model="searchForm.updateUser" placeholder="请输入更新人编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="更新时间" prop="updateTime">
        <el-date-picker v-model="searchForm.updateTime" value-format="yyyy-MM-dd" placeholder="请输入更新时间" @change="search"/>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="searchForm.remark" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="订单主键（orders）" prop="orderId">
        <el-input v-model="searchForm.orderId" placeholder="请输入订单主键（orders）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="searchForm.title" placeholder="请输入标题" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="日志内容" prop="logInfo">
        <el-input v-model="searchForm.logInfo" placeholder="请输入日志内容" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="操作类型" prop="objType">
        <el-input v-model="searchForm.objType" placeholder="请输入操作类型" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="操作人" prop="memberId">
        <el-input v-model="searchForm.memberId" placeholder="请输入操作人" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="操作前数据" prop="beforeInfo">
        <el-input v-model="searchForm.beforeInfo" placeholder="请输入操作前数据" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="操作后数据" prop="afterInfo">
        <el-input v-model="searchForm.afterInfo" placeholder="请输入操作后数据" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="订单状态:0=待接单；1=已接单；2=进行中；3=已完成；99=已取消；" prop="orderStatus">
        <el-input v-model="searchForm.orderStatus" placeholder="请输入订单状态:0=待接单；1=已接单；2=进行中；3=已完成；99=已取消；" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:orderlog:create', 'business:orderlog:delete']">
        <li><el-button type="primary" @click="$refs.operaOrderLogWindow.open('新建订单操作日志')" icon="el-icon-plus" v-permissions="['business:orderlog:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:orderlog:delete']">删除</el-button></li>
      </ul>
      <el-table
          :height="tableHeightNew"
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="主键" min-width="100px"></el-table-column>
        <el-table-column prop="deleted" label="是否已删除 0未删除 1已删除" min-width="100px"></el-table-column>
        <el-table-column prop="createUser" label="创建人编码" min-width="100px"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="updateUser" label="更新人编码" min-width="100px"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" min-width="100px"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="orderId" label="订单主键（orders）" min-width="100px"></el-table-column>
        <el-table-column prop="title" label="标题" min-width="100px"></el-table-column>
        <el-table-column prop="logInfo" label="日志内容" min-width="100px"></el-table-column>
        <el-table-column prop="objType" label="操作类型" min-width="100px"></el-table-column>
        <el-table-column prop="memberId" label="操作人" min-width="100px"></el-table-column>
        <el-table-column prop="beforeInfo" label="操作前数据" min-width="100px"></el-table-column>
        <el-table-column prop="afterInfo" label="操作后数据" min-width="100px"></el-table-column>
        <el-table-column prop="orderStatus" label="订单状态:0=待接单；1=已接单；2=进行中；3=已完成；99=已取消；" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:orderlog:update', 'business:orderlog:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaOrderLogWindow.open('编辑订单操作日志', row)" icon="el-icon-edit" v-permissions="['business:orderlog:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:orderlog:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaOrderLogWindow ref="operaOrderLogWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaOrderLogWindow from '@/components/business/OperaOrderLogWindow'
export default {
  name: 'OrderLog',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaOrderLogWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        deleted: '',
        createUser: '',
        createTime: '',
        updateUser: '',
        updateTime: '',
        remark: '',
        orderId: '',
        title: '',
        logInfo: '',
        objType: '',
        memberId: '',
        beforeInfo: '',
        afterInfo: '',
        orderStatus: ''
      }
    }
  },
  created () {
    this.config({
      module: '订单操作日志',
      api: '/business/orderLog',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
